import { useState } from 'react';
import { fieldNames } from '../../components/LegalForm/steps/step6/utils';

const {
  BIRTH_CITY,
  BIRTH_COUNTRY,
  CITY,
  EMAIL,
  MOBILE_NUMBER,
  COUNTRY_CODE,
  COUNTRY,
  CITY_VILLAGE,
  APARTMENT_NUMBER,
  HOME_NUMBER,
  STREET,
  DUAL_CITIZENSHIP,
  IS_ACTUAL_ADDRESS,
  LEGAL_ADDRESS,
  ACTUAL_ADDRESS,
  VILLAGE,
  SEX,
  DUAL_CITIZENSHIP_COUNTRY,
  COMPANY_REGISTRATION_DATE,
  COMPANY_JURIDICAL_ADDRESS,
  COMPANY_WEB_PAGE_ADDRESS,
  CAPITAL_SOURCES,
  CAPITAL_SOURCES_IN_BANK,
  CAPITAL_SOURCES_IN_BANK_OTHER,
  WHERE_YOU_HAVE_BANK_ACCOUNTS,
  PLEASE_SPECIFY_BANKS,
  MONEY_SOURCES,
  WEALTH_SOURCES,
  PLEASE_SPECIFY_INCOME_SOURCE,
  PLEASE_SPECIFY_WEALTH,
  CONFIRMATION_STATUS,
  BUSINESS_ACTIVITY_IN_GEORGIA,
  BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION,
  INFO_COUNTERPARTIES,
  EXPORT_CONNECTIONS,
  IS_COMPANY_EXP_IMP,
  CATEGORY_OF_POLITICALLY_EXPOSED,
  INFORMATION_ABOUT_RELATED_PEP,
  INCOME_FROM_OTHER_BUSINESS_ACTIVITIES,
  OTHER_BUSINESS_ACTIVITIES,
} = fieldNames;

const initAddress = {
  [COUNTRY]: '',
  [CITY]: '',
  [STREET]: '',
  [CITY_VILLAGE]: '',
  [HOME_NUMBER]: '',
  [APARTMENT_NUMBER]: '',
  [VILLAGE]: '',
};

const initialValues = {
  [BIRTH_COUNTRY]: '',
  [BIRTH_CITY]: '',
  [EMAIL]: '',
  [MOBILE_NUMBER]: '',
  [COUNTRY_CODE]: '',
  [DUAL_CITIZENSHIP_COUNTRY]: '',
  [DUAL_CITIZENSHIP]: false,
  [IS_ACTUAL_ADDRESS]: false,
  [SEX]: '',
  [COMPANY_REGISTRATION_DATE]: '',
  [COMPANY_WEB_PAGE_ADDRESS]: '',
  [BUSINESS_ACTIVITY_IN_GEORGIA]: '',
  [BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION]: '',
  [INCOME_FROM_OTHER_BUSINESS_ACTIVITIES]: '',
  [OTHER_BUSINESS_ACTIVITIES]: '',
  [CATEGORY_OF_POLITICALLY_EXPOSED]: '',
  [EXPORT_CONNECTIONS]: '',
  [IS_COMPANY_EXP_IMP]: '',
  [INFO_COUNTERPARTIES]: '',
  [CAPITAL_SOURCES]: [],
  [CAPITAL_SOURCES_IN_BANK]: [],
  [CAPITAL_SOURCES_IN_BANK_OTHER]: '',
  [WHERE_YOU_HAVE_BANK_ACCOUNTS]: [],
  [PLEASE_SPECIFY_BANKS]: '',
  [MONEY_SOURCES]: [],
  [PLEASE_SPECIFY_INCOME_SOURCE]: '',
  [WEALTH_SOURCES]: [],
  [PLEASE_SPECIFY_WEALTH]: '',
  [INFORMATION_ABOUT_RELATED_PEP]: '',
  [CONFIRMATION_STATUS]: false,
  [LEGAL_ADDRESS]: { ...initAddress },
  [ACTUAL_ADDRESS]: { ...initAddress },
};

function useStepSixValues() {
  const [stepSixValues, setStepSixValues] = useState(initialValues);
  return { stepSixValues, setStepSixValues };
}

export default useStepSixValues;
